import request from '@/utils/request'
import uploads from '@/utils/uploads'

export function talentCreate (data) {
  return request({
    url: '/amrep/talent/create',
    method: 'post',
    data
  })
}

export function talentSearch (data) {
  return request({
    url: '/amrep/talent/search',
    method: 'post',
    data
  })
}

export function talentCreateLabel (data) {
  return request({
    url: '/amrep/talent/createLabel',
    method: 'post',
    data
  })
}

export function talentCreateWork (data) {
  return request({
    url: '/amrep/talent/createWork',
    method: 'post',
    data
  })
}

export function talentCreateEvaluation (data) {
  return request({
    url: '/amrep/talent/createEvaluation',
    method: 'post',
    data
  })
}

export function talentItems (params) {
  return request({
    url: '/amrep/talent/items',
    method: 'get',
    params
  })
}

export function talentUpdate (data) {
  return request({
    url: '/amrep/talent/update',
    method: 'put',
    data
  })
}

export function talentDelete (data) {
  return request({
    url: '/amrep/talent/delete/' + data.id,
    method: 'delete'
  })
}

export function talentDetails (params) {
  return request({
    url: '/amrep/talent/details/' + params.id,
    method: 'get'
  })
}

export function talentUploadsFile (data) {
  return uploads({
    url: '/amrep/talent/uploadsFile',
    method: 'post',
    data
  })
}

export function talentPortrait (data) {
  return uploads({
    url: '/amrep/talent/updatePortrait',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/talent.js